import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const notify = inject(NotificationService);

  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401) {
        // Don't redirect to login for public API endpoints
        const publicPaths = ['/api/access-requests', '/auth/google/callback'];
        const isPublic = publicPaths.some((p) => req.url.includes(p));
        if (!isPublic) {
          router.navigate(['/login']);
        }
      } else if (err.status === 403) {
        notify.error('You do not have permission to perform this action.');
      } else if (err.status >= 500) {
        notify.error('A server error occurred. Please try again later.');
      }
      return throwError(() => err);
    }),
  );
};
